import { render, staticRenderFns } from "./locatie-dakkapel.vue?vue&type=template&id=2f689c30"
import script from "./locatie-dakkapel.vue?vue&type=script&lang=js"
export * from "./locatie-dakkapel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports